"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: 'デジタルコレクション',
    organizationId: 'U1gHXDNVI8Ofh4lnYVgQ',
    applicationKey: 'nizicon',
    applicationType: 'standalone',
    artistId: 'r9TsyvMSM8XU3CHI6kRYCZ89oFO2',
    version: '1.2',
    ionicAppId: '012f6ee8',
    platform: ['web', 'native'],
    ios: {
        bundleId: 'com.utoniq.nizicon',
        appId: '1617011651',
    },
    android: {
        bundleId: 'com.utoniq.nizicon',
    },
    deeplinkUrl: 'https://nizicon.utoniq.com',
    helpUrl: 'https://help.utoniq.com/ja/collections/3562309',
    applink: 'nizicon.utoniq.com',
    deeplinkProd: 'nizicon.utoniq.com',
    custom: {
        modules: {
            tutorial: true,
            trade: true,
            membership: true,
            thread: true,
            prepaidPoint: { chargeable: true },
            gacha: true,
            item: true,
            campaign: true,
            mission: true,
            konbiniPayment: true,
        },
        tutorials: [
            'images/tutorial/Tutorial01.jpg',
            'images/tutorial/Tutorial02.jpg',
            'images/tutorial/Tutorial03.jpg',
            'images/tutorial/Tutorial04.jpg',
            'images/tutorial/Tutorial05.jpg',
        ],
        globalTabs: ['home', 'notifications', 'myProfile'],
        artistTabs: ['home', 'collections', 'gachas', 'trade', 'myProfile'],
    },
});
